<template>
    <form @submit.prevent="submit" class="form jgile-form">
        <slot :form="form" :get="get" :set="set" :submit="submit">
            <form-fields :fields="fields" v-model="form"></form-fields>
        </slot>
    </form>
</template>

<script>
import FormFields from './FormFields';
import Form from '../forms/Form';

export default {
    name: 't-form',
    components: { FormFields },
    props: {
        value: {
            required: false,
        },
        fields: {
            required: false,
        },
        action: {
            required: false,
            default: 'POST',
            type: String,
        },
        method: {
            default: 'post',
        },
        busy: {
            default: false,
        },
        onSuccess: {
            default: false,
        },
        clear: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        form: new Form({}),
    }),
    methods: {
        get(attr) {
            return _.get(this.form, attr);
        },
        set(attr, value) {
            _.set(this.form, attr, value);
        },
        submit() {
            if (this.action) {
                return this.form.sendForm(this.method, this.action).then((response) => {
                    this.$emit('success', response);
                });
            } else {
                return this.$emit('submit', this.form);
            }
        },
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.form = new Form(newVal);
                }
            },
        },
    },
};
</script>
